import Messages from "../constants/Messages";

const ErrorUtils = {
    processError : (e) => {
        const code = e?.response?.data?.error?.code || e.code;
        if(code) {
            return Messages.ERROR_CODES[code] || Messages.ERROR_CODES.ERR_GENERIC
        }
        return Messages.ERROR_CODES.ERR_GENERIC;
    }
}

export default ErrorUtils;
